
const contactForm = {
  'contactMe.header': '¡No puedo esperar, contáctame!',
  'contactMe.instructions': 'Por favor completa el siguiente formulario para que nuestros representantes puedan ponerse en contacto contigo.',
  'contactMe.name': 'Nombre',
  'contactMe.lastName': 'Apellido',
  'contactMe.email': 'Correo Electrónico (opcional)',
  'contactMe.country': 'País',
  'contactMe.whatsappNumber': 'Número de WhatsApp',
  'contactMe.countryCode': 'Código de país',
  'contactMe.language': 'Idioma Preferido',
  'contactMe.message': 'Mensaje (opcional)',
  'contactMe.submit': 'Enviar',
  'contactMe.submitting': 'Enviando...',
  'contactMe.success.title': '¡Gracias por contactarnos!',
  'contactMe.success.message': 'Tu información ha sido enviada exitosamente. Un representante de The Club se pondrá en contacto contigo pronto.',
  'contactMe.placeholders.name': 'Ingresa tu nombre',
  'contactMe.placeholders.lastName': 'Ingresa tu apellido',
  'contactMe.placeholders.email': 'Ingresa tu Correo Electrónico',
  'contactMe.placeholders.country': 'Selecciona tu país',
  'contactMe.placeholders.countryCode': 'Código',
  'contactMe.placeholders.whatsappNumber': 'Número de WhatsApp',
  'contactMe.placeholders.language': 'Indica tu idioma preferido',
  'contactMe.placeholders.message': 'Escribe tu mensaje aquí',
  'contactMe.errors.name': 'El nombre es requerido',
  'contactMe.errors.lastName': 'El apellido es requerido',
  'contactMe.errors.email': 'Dirección de correo electrónico inválida',
  'contactMe.errors.country': 'El país es requerido',
  'contactMe.errors.countryCode': 'El código de país es requerido',
  'contactMe.errors.whatsappNumber': 'El número de WhatsApp es requerido',
  'contactMe.errors.language': 'El idioma es requerido',
  'contactMe.errors.messageMaxLength': 'El mensaje no puede exceder {max} caracteres',
  'contactMe.errors.submission': 'Error al enviar el formulario',
  'contactMe.errors.generic': 'Algo salió mal. Por favor intenta de nuevo.',
  'contactMe.page.title': 'Comienza a Ganar Antes que Todos',
};

export default contactForm;
